import type { ModuleDef } from "./types";
import { PreTriageMarketPriceModule, preTriageMarketPriceConfig } from "./modules/PreTriageMarketPriceModule";
import { FunctionalTriageModule, functionalTriageConfig } from "./modules/FunctionalTriageModule";
import { DynamicPhasesModule, dynamicPhasesConfig } from "./modules/DynamicPhasesModule";
import { QualityGradingModule, qualityGradingConfig } from "./modules/QualityGradingModule";
import { HarvestComponentsPickerModule, harvestComponentsPickerConfig } from "./modules/HarvestComponentsPickerModule";
import { PassportSummaryModule, passportSummaryConfig } from "./modules/PassportSummaryModule";
import { ResultsSummaryModule, resultsSummaryConfig } from "./modules/ResultsSummaryModule";
import { WorkflowCompleteModule, workflowCompleteConfig } from "./modules/WorkflowCompleteModule";

export const MODULE_REGISTRY: Record<string, ModuleDef<any>> = {
  workflow_complete: {
    key: "workflow_complete",
    label: "Workflow complete",
    description: "Terminal stage shown after a work order is finished. Configurable summary + passport link.",
    component: WorkflowCompleteModule,
    configSchema: workflowCompleteConfig,
    defaultConfig: {
      passportLink: true,
      showCompletedMeta: true,
      showTotalDuration: true,
      sections: [],
    },
  },
  pre_triage_market_price: {
    key: "pre_triage_market_price",
    label: "Pre-triage market price",
    description: "Look up the current market price before deciding what to do.",
    component: PreTriageMarketPriceModule,
    configSchema: preTriageMarketPriceConfig,
    defaultConfig: { skipIfCachedDays: 30 },
  },
  functional_triage: {
    key: "functional_triage",
    label: "Functional triage",
    description: "Quick functional checks before disassembly.",
    component: FunctionalTriageModule,
    configSchema: functionalTriageConfig,
    defaultConfig: { questions: [] },
  },
  dynamic_phases: {
    key: "dynamic_phases",
    label: "Dynamic phases (6-phase engine)",
    description: "Runs the configured workflow_items in 6 sequential phases.",
    component: DynamicPhasesModule,
    configSchema: dynamicPhasesConfig,
    defaultConfig: {},
    isDynamicPhases: true,
  },
  quality_grading: {
    key: "quality_grading",
    label: "Quality grading",
    description: "Assign a final A/B/C grade to the appliance.",
    component: QualityGradingModule,
    configSchema: qualityGradingConfig,
    defaultConfig: { grades: ["A", "B", "C"] },
    appliesTo: ["refurbishment"],
  },
  harvest_components_picker: {
    key: "harvest_components_picker",
    label: "Harvest components picker",
    description: "Pick recoverable components and assign storage bins.",
    component: HarvestComponentsPickerModule,
    configSchema: harvestComponentsPickerConfig,
    defaultConfig: {},
    appliesTo: ["harvesting"],
  },
  passport_summary: {
    key: "passport_summary",
    label: "Passport summary",
    description: "Build the Digital Product Passport.",
    component: PassportSummaryModule,
    configSchema: passportSummaryConfig,
    defaultConfig: {},
  },
  results_summary: {
    key: "results_summary",
    label: "Results summary",
    description: "Wrap-up screen with totals, exports and CTAs.",
    component: ResultsSummaryModule,
    configSchema: resultsSummaryConfig,
    defaultConfig: {},
  },
};

export function getModuleDef(key: string): ModuleDef | undefined {
  return MODULE_REGISTRY[key];
}

export function listModules(workflowKey?: string): ModuleDef[] {
  return Object.values(MODULE_REGISTRY).filter(
    (m) => !m.appliesTo || !workflowKey || m.appliesTo.includes(workflowKey),
  );
}
